import { ItemPrice } from '@kinet-open-network/client/item-prices/data-access';
import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  IServPackage,
  ServiceType,
  Source,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';
import { ServPackageFee } from './serv-package-fee.model';

export class ServPackage
  extends BaseModel<ServPackage, 'ServPackage'>
  implements IServPackage
{
  static override readonly modelName: AbilitySubjectType = 'ServPackage';

  name!: string;
  code!: string;
  type!: ServiceType;
  speedProfileUp?: string;
  speedProfileDown?: string;
  description?: string;
  serviceProfile?: string;
  lineProfile?: string;
  source?: Source;
  offerId?: number;
  hbo?: boolean;
  offerItemsLimit?: number;
  hboMax?: boolean;

  @Type(() => ServPackageFee)
  servPackagesFees?: ServPackageFee[];

  @Type(() => ItemPrice)
  prices?: ItemPrice[];

  get activePrice() {
    return this.prices
      ?.filter((p) => p.type === 'withCommitment')
      .find((price) => price.isActive);
  }

  get priceWithCommitment() {
    return this.prices
      ?.filter((p) => p.type === 'withCommitment')
      .find((p) => p.isActive)?.price;
  }

  get priceWithoutCommitment() {
    return this.prices
      ?.filter((p) => p.type === 'withoutCommitment')
      .find((p) => p.isActive)?.price;
  }

  allowProfilesChange?: boolean;

  speedUp?: number;
  speedDown?: number;

  maxDevicesNumber?: number;
  minDevicesNumber?: number;
  allowedOnts?: string[];
  allowedMeshes?: string[];
  allowedSetTopBoxes?: string[];
  allowedWifiReceivers?: string[];
  forbidInZone?: boolean;
  allowCustomPrice?: boolean;
  allowSystemPrice?: boolean;
}
